import { gql } from '@apollo/client';
export const USER_REGISTER = gql`
    mutation RegisterUser($userRegisterInput: UserRegisterInput!) {
        registerUser(userRegisterInput: $userRegisterInput) {
            otpExpiresAt
        }
    }
`;
export const USER_LOGIN = gql`
    mutation UserLogin($loginUserInput: LoginUserInput!) {
        userLogin(loginUserInput: $loginUserInput) {
            userData {
                companyId
                inCompany
                token {
                    accessToken
                    accessTokenExpiresIn
                    refreshToken
                    refreshTokenExpiresIn
                }
                user {
                    _id
                    acceptedEmailCommunication
                    acceptedTAndC
                    companyCreator
                    email
                    firstName
                    jobTitle
                    lastLoggedInAt
                    lastName
                    mobileNum
                    plan
                    profileImage
                    receiveNotification
                    registeredWithGoogle
                    stripeCustomerId
                    subscriptionRenewable
                    subscriptionStatus
                    hasClickedIntegrationButton
                    hasViewedIntegrationModal
                    userName
                    verifiedAt
                }
            }
            otpData {
                message
                otpExpiresAt
            }
        }
    }
`;
export const SEND_EMAIL_OTP = gql`
    mutation SendEmailOtp($sendEmailOtpInput: SendEmailOtpInput!) {
        sendEmailOtp(sendEmailOtpInput: $sendEmailOtpInput) {
            message
            otpExpiresAt
        }
    }
`;
export const VERIFY_EMAIL_OTP = gql`
    mutation VerifyEmailOtp($verifyEmailOtpInput: VerifyEmailOtpInput!) {
        verifyEmailOtp(verifyEmailOtpInput: $verifyEmailOtpInput) {
            userData {
                companyId
                inCompany
                token {
                    accessToken
                    accessTokenExpiresIn
                    refreshToken
                    refreshTokenExpiresIn
                }
                user {
                    _id
                    acceptedEmailCommunication
                    acceptedTAndC
                    companyCreator
                    email
                    firstName
                    jobTitle
                    lastLoggedInAt
                    lastName
                    mobileNum
                    plan
                    profileImage
                    receiveNotification
                    registeredWithGoogle
                    stripeCustomerId
                    subscriptionRenewable
                    subscriptionStatus
                    userName
                    verifiedAt
                }
            }
        }
    }
`;
export const ADD_TEAM_MEMBER = gql`
    mutation AddTeamMember($teamMemberInput: AddTeamMemberDto!) {
        addTeamMember(teamMemberInput: $teamMemberInput) {
            message
        }
    }
`;

export const UPDATE_TEAM_MEMBER = gql`
    mutation UpdateTeamMemberDetail($teamMemberInput: UpdateTeamMemberDetailDto!) {
        updateTeamMemberDetail(teamMemberInput: $teamMemberInput) {
            message
        }
    }
`;

export const DELETE_TEAM_MEMBER = gql`
    mutation DeleteTeamMember($teamMemberInput: TeamMemberDetailInputDto!) {
        deleteTeamMember(teamMemberInput: $teamMemberInput) {
            message
        }
    }
`;

export const UPDATE_TEAM_MEMBER_PERMISSIONS = gql`
    mutation UpdateTeamMemberPermissions($teamMemberPermissionsInput: UpdateTeamMemberPermissionInput!) {
        updateTeamMemberPermissions(teamMemberPermissionsInput: $teamMemberPermissionsInput) {
            message
        }
    }
`;

export const INVITED_MEMBER_UPDATE = gql`
    mutation Mutation($inviteMemberUpdateInput: InviteMemberUpdateInput!) {
        addNewTeamMemberPassword(inviteMemberUpdateInput: $inviteMemberUpdateInput) {
            message
        }
    }
`;

export const VERIFY_TEAM_MEMBER_TOKEN = gql`
    mutation Mutation($verifyEmailInviteTokenInput: VerifyEmailInviteMemberTokenInput!) {
        verifyEmailInviteMember(verifyEmailInviteTokenInput: $verifyEmailInviteTokenInput) {
            email
            firstName
            lastName
            legalBusinessName
            mobileNum
            userId
            verifiedAt
        }
    }
`;

export const SELECT_COMPANY_LOGIN = gql`
    mutation SelectCompanyForLogin($companyId: String!, $fingerprint: String!) {
        selectCompanyForLogin(companyId: $companyId, fingerprint: $fingerprint) {
            userData {
                companyId
                inCompany
                isInviteTeamSkipped
                quantity
                token {
                    accessToken
                    accessTokenExpiresIn
                    refreshToken
                    refreshTokenExpiresIn
                }
                user {
                    _id
                    acceptedEmailCommunication
                    acceptedTAndC
                    companyCreator
                    email
                    firstName
                    jobTitle
                    lastLoggedInAt
                    lastName
                    mobileNum
                    plan
                    profileImage
                    receiveNotification
                    registeredWithGoogle
                    stripeCustomerId
                    subscriptionRenewable
                    subscriptionStatus
                    userName
                    verifiedAt
                    hasClickedIntegrationButton
                    hasViewedIntegrationModal
                    hasClickedIntegrationButton
                }
            }
        }
    }
`;

export const UPDATE_FIREBASE_TOKEN = gql`
    mutation updateFirebaseToken($companyId: String!, $fingerprint: String!, $firebaseToken: String!) {
        updateFirebaseToken(companyId: $companyId, fingerprint: $fingerprint, firebaseToken: $firebaseToken) {
            message
        }
    }
`;

export const ADD_TEAM_NAME = gql`
    mutation Mutation($teamNameInput: AddTeamNameInputDto!) {
        addTeamName(teamNameInput: $teamNameInput) {
            teamName
        }
    }
`;

export const DELETE_COMPANY = gql`
    mutation RemoveCompany($removeCompanyInput: IdOnly!) {
        removeCompany(removeCompanyInput: $removeCompanyInput) {
            message
        }
    }
`;

export const CREATE_RESPONSE_TEMPLATE = gql`
    mutation CreateResponseTemplate($responseTemplateInput: ResponseTemplateInput!) {
        createResponseTemplate(responseTemplateInput: $responseTemplateInput) {
            _id
            attachments
            companyId
            content
            deleted
            starred
            title
            updatedAt
        }
    }
`;

export const UPDATE_RESPONSE_TEMPLATE = gql`
    mutation UpdateResponseTemplate($responseTemplateEditInput: ResponseTemplateEditInput!) {
        updateResponseTemplate(responseTemplateEditInput: $responseTemplateEditInput) {
            _id
            attachments
            companyId
            content
            deleted
            starred
            title
            updatedAt
        }
    }
`;
export const PIN_ANNOUNCEMENT = gql`
    mutation PinAnnouncement($announcementInput: AnnouncementPinInput!) {
        pinAnnouncement(announcementInput: $announcementInput) {
            status
        }
    }
`;

export const ADD_ENQUIRY_REPONSE = gql`
    mutation AddEnquiryResponse($enquiryResponseInput: EnquiryResponseInput!) {
        addEnquiryResponse(enquiryResponseInput: $enquiryResponseInput) {
            _id
            attachments
            responder {
                _id
                firstName
                lastName
                profileImage
                userName
            }
            rating
            links
            enquiryId
            fromDiolog
            content
            boardPriority
            audio
            title
            createdAt
        }
    }
`;
export const SET_ARCHIVED_ENQUIRIES = gql`
    mutation ArchiveEnquiries($archiveEnquiriesInput: ArchiveOrResolveEnquiriesInput!) {
        archiveEnquiries(archiveEnquiriesInput: $archiveEnquiriesInput) {
            message
        }
    }
`;
export const SET_RESOLVED_ENQUIRIES = gql`
    mutation ResolveEnquiries($resolveEnquiriesInput: ArchiveOrResolveEnquiriesInput!) {
        resolveEnquiries(resolveEnquiriesInput: $resolveEnquiriesInput) {
            message
        }
    }
`;
export const SET_UNARCHIVED_ENQUIRIES = gql`
    mutation UnarchiveEnquiries($unarchiveEnquiriesInput: ArchiveOrResolveEnquiriesInput!) {
        unarchiveEnquiries(unarchiveEnquiriesInput: $unarchiveEnquiriesInput) {
            message
        }
    }
`;
export const ASSIGN_CATEGORYIES = gql`
    mutation AssignEnquiriesToCategory($assignToCategoryInput: AssignEnquiriesToCategoriesInput!) {
        assignEnquiriesToCategory(assignToCategoryInput: $assignToCategoryInput) {
            message
        }
    }
`;
export const USER_LOGOUT = gql`
    mutation UserLogout($logoutUserInput: LogoutUserInput!) {
        userLogout(logoutUserInput: $logoutUserInput) {
            status
        }
    }
`;
export const READ_NOTIFICATION_BY_ID = gql`
    mutation ReadNotification($notificaion: NotificationIdOnlyInput!) {
        readNotification(notificaion: $notificaion) {
            message
        }
    }
`;
export const INITIAL_INVITE_TEAM = gql`
    mutation InitialAddTeamMember($initalTeamMemberInput: InitialAddTeamMemberDto!) {
        initialAddTeamMember(initalTeamMemberInput: $initalTeamMemberInput) {
            message
        }
    }
`;

export const RESEND_INVITATION = gql`
    mutation resendInvitation($resendInvitationInput: ResendInvitationDto!) {
        resendInvitation(resendInvitationInput: $resendInvitationInput) {
            message
        }
    }
`;

export const SKIP_INVITE_TEAM = gql`
    mutation SkipInviteTeam($companyId: String!) {
        skipInviteTeam(companyId: $companyId) {
            message
        }
    }
`;
export const ONBOARDING_INVITE_TEAM = gql`
    mutation UpdateInviteInvestorChecklist($updateInviteInvestorChecklistInput: CompanyIdInput!) {
        updateInviteInvestorChecklist(updateInviteInvestorChecklistInput: $updateInviteInvestorChecklistInput) {
            addCompanyBio
            addCompanyLogo
            addExecutive
            addFAQ
            completionTime
            inviteInvestors
            showOnboardingChecklist
        }
    }
`;
/**Question Registry */
export const CREATE_QUESTION_REGISTRY = gql`
    mutation AddQuestionRegistry($addQuestionRegistryInput: AddQuestionRegistryInput!) {
        addQuestionRegistry(addQuestionRegistryInput: $addQuestionRegistryInput) {
            status
        }
    }
`;
/**Question Registry Mutation Update Question Registry*/
export const UPDATE_QUESTION_REGISTRY = gql`
    mutation UpdateQuestionRegistries($editQuestionRegistryInput: UpdateQuestionReigstriesInput!) {
        updateQuestionRegistries(editQuestionRegistryInput: $editQuestionRegistryInput) {
            status
        }
    }
`;

export const EDIT_QUESTION_REGISTRY = gql`
    mutation EditSingleQuestionRegistry($editQuestionRegistryInput: SaveOrDraftQuestionReigstryInput!) {
        editSingleQuestionRegistry(editQuestionRegistryInput: $editQuestionRegistryInput) {
            status
        }
    }
`;
/**Questions Lock Mutation */
export const UPDATE_LOCK_QUESTION_DETAIL = gql`
    mutation UpdateLockedTime($updateLockedTimeInput: UpdateLockedTimeInput!) {
        updateLockedTime(updateLockedTimeInput: $updateLockedTimeInput) {
            message
            lockedTime
        }
    }
`;
/**Question Registry Lock Mutation */
export const UPDATE_LOCK_QUESTION_REGISTRY_DETAIL = gql`
    mutation UpdateQuestionRegistryLockedTime($updateQuestionRegistryLockedTime: UpdateLockedTimeQuestionRegistryInput!) {
        updateQuestionRegistryLockedTime(updateQuestionRegistryLockedTime: $updateQuestionRegistryLockedTime) {
            lockedTime
            message
        }
    }
`;

/**Remove Question Category From Question Enquiry*/
export const REMOVE_QUESTION_CATEGORY_FROM_ENQUIRY = gql`
    mutation RemoveEnquiriesToCategory($removeCategoryInput: AssignEnquiriesToCategoriesInput!) {
        removeEnquiriesToCategory(removeCategoryInput: $removeCategoryInput) {
            message
        }
    }
`;
/**Multiple Questions in Question Registry Via CSV Mutation */
export const ADD_MULTIPLE_QUESTIONS_IN_QUESTION_REGISTRY = gql`
    mutation AddMultipleQuestionRegistris($addMultipleQuestionRegistryInput: MultipleQuestionRegistryInput!) {
        addMultipleQuestionRegistris(addMultipleQuestionRegistryInput: $addMultipleQuestionRegistryInput) {
            status
        }
    }
`;
/**Update Kanban board question priority */
export const UPDATE_KANBAN_QUESTION_PRIORITY = gql`
    mutation UpdateKanbanPriorityUpdateResponse($kanbanPriorityUpdateInput: KanbanEnquiryPriorityUpdateInput!) {
        updateKanbanPriorityUpdateResponse(kanbanPriorityUpdateInput: $kanbanPriorityUpdateInput) {
            message
            boardPriority
        }
    }
`;
/**Create, Update And Remove Enquiry Category */
export const CREATE_ENQUIRY_CATEGORY = gql`
    mutation CreateEnquiryCategory($enquiryCategoryInput: CreateEnquiryCategoryInput!) {
        createEnquiryCategory(enquiryCategoryInput: $enquiryCategoryInput) {
            hoverCategoryColor
            createdBy
            companyId
            categoryColor
            textColor
            _id
            name
        }
    }
`;
export const UPDATE_ENQUIRY_CATEGORY = gql`
    mutation UpdateEnquiryCategory($enquiryCategoryInput: EditEnquiryCategory!) {
        updateEnquiryCategory(enquiryCategoryInput: $enquiryCategoryInput) {
            _id
            categoryColor
            companyId
            createdBy
            name
            hoverCategoryColor
            textColor
        }
    }
`;
export const REMOVE_ENQUIRY_CATEGORY = gql`
    mutation DeleteEnquiryCategory($enquiryCategory: EnquiryCategoryDeleteInput!) {
        deleteEnquiryCategory(enquiryCategory: $enquiryCategory) {
            _id
            companyId
            createdBy
            name
        }
    }
`;

export const SET_QUICK_RESPONSE_VIEWED_INFO = gql`
    mutation Mutation {
        setQuickResponseViewedInfo {
            message
        }
    }
`;
export const SET_ENQUIRY_OPEN = gql`
    mutation Mutation($reOpenEnquiryInput: EnquiryReOpenInput!) {
        reopenEnquiry(reOpenEnquiryInput: $reOpenEnquiryInput) {
            message
        }
    }
`;
export const CHANGE_EMAIL_ADDRESS = gql`
    mutation ChangeEmailAddress($changeEmailAddressInput: ChangeEmailInput!) {
        changeEmailAddress(changeEmailAddressInput: $changeEmailAddressInput) {
            message
            otpExpiresAt
        }
    }
`;

export const uploadChunkFile = gql`
    mutation UploadChunk($chunkIndex: Float!, $file: Upload!, $fileName: String!, $totalChunks: Float!) {
        uploadChunk(chunkIndex: $chunkIndex, file: $file, fileName: $fileName, totalChunks: $totalChunks) {
            attachmentDuration
            key
            thumbnailKey
        }
    }
`;

export const ADD_UPDATE_NOTE = gql`
    mutation CreateUpdateEnquiryNotes($createEnquiryNoteInput: AddUpdateEnquiryNotesInput!) {
        createUpdateEnquiryNotes(createEnquiryNoteInput: $createEnquiryNoteInput) {
            _id
            companyId
            createdBy
            currentEditsUsing
            description
            editedBy
            enquiryId
            locked
            editedTexts {
                editedBy
                editedText
                node
            }
        }
    }
`;
export const LOCK_UNLOCK_NOTES = gql`
    mutation LockUnlockNotes($lockUnlockInput: UpdateLockedStatusInput!) {
        lockUnlockNotes(lockUnlockInput: $lockUnlockInput) {
            _id
            companyId
            createdBy
            currentEditsUsing
            description
            editedBy
            enquiryId
            locked
            editedTexts {
                editedBy
                editedText
                node
            }
        }
    }
`;
export const CLOSE_ENQUIRY = gql`
    mutation CloseEnquiry($closeEnquiryInput: EnquiryCloseInput!) {
        closeEnquiry(closeEnquiryInput: $closeEnquiryInput) {
            message
        }
    }
`;
export const UPDATE_HAS_VIEWED_INTEGRATION = gql`
    mutation UpdateIntegrationModalSeen($updateIntegrateModalSeenInput: UpdateIntegrationViewedInput!) {
        updateIntegrationModalSeen(updateIntegrateModalSeenInput: $updateIntegrateModalSeenInput) {
            hasViewedIntegrationModal
            message
        }
    }
`;
export const UPDATE_HAS_CLICKED_INTEGRATION = gql`
    mutation UpdateIntegrationModalClicked($updateIntegrationModalClicked: UpdateIntegrationClicked!) {
        updateIntegrationModalClicked(updateIntegrationModalClicked: $updateIntegrationModalClicked) {
            hasClickedIntegrationButton
            message
        }
    }
`;
export const ADD_UPDATE_EDITS_ON_NOTE = gql`
    mutation AddUpdateEditsForNotes($addUpdateEditsForNotesInput: AddUpdateEnquiryNotesEditsInput!) {
        addUpdateEditsForNotes(addUpdateEditsForNotesInput: $addUpdateEditsForNotesInput) {
            _id
            companyId
            createdBy
            currentEditsUsing
            description
            editedBy
            enquiryId
            editedTexts {
                editedBy
                editedText
                node
            }
            locked
        }
    }
`;

export const UPDATE_COMPANY_LINK = gql`
    mutation UpdateCompanyLink($updateCompanyLinkInput: UpdateCompanyLinkInput!) {
        updateCompanyLink(updateCompanyLinkInput: $updateCompanyLinkInput) {
            companyLinks {
                _id
                priorityOrder
                title
                type
                url
                locked
            }
        }
    }
`;

export const ADD_COMPANY_LINK = gql`
    mutation Mutation($addCompanyLinkInput: AddCompanyLinkInput!) {
        addCompanyLinks(addCompanyLinkInput: $addCompanyLinkInput) {
            companyLinks {
                _id
                priorityOrder
                title
                type
                url
                locked
            }
        }
    }
`;

export const DELETE_COMPANY_LINK = gql`
    mutation DeleteCompanyLink($deleteCompanyLinkInput: DeleteCompanyLinkInput!) {
        deleteCompanyLink(deleteCompanyLinkInput: $deleteCompanyLinkInput) {
            companyLinks {
                _id
                priorityOrder
                title
                type
                url
                locked
            }
        }
    }
`;

export const DRAG_AND_DROP_COMPANY_LINK = gql`
    mutation DragAndDropUpdateCompanyLinkInput($dragAndDropUpdateCompanyLinkInput: DragAndDropUpdateCompanyLinkListInput!) {
        dragAndDropUpdateCompanyLinkInput(dragAndDropUpdateCompanyLinkInput: $dragAndDropUpdateCompanyLinkInput) {
            companyLinks {
                _id
                priorityOrder
                title
                type
                url
                locked
            }
        }
    }
`;

export const BULK_ARCHIVE_ENQUIRIES = gql`
    mutation Mutation($bulkArchiveEnquiriesInput: ArchiveOrResolveEnquiriesInput!) {
        bulkArchiveEnquiries(bulkArchiveEnquiriesInput: $bulkArchiveEnquiriesInput) {
            message
        }
    }
`;

export const BULK_UNARCHIVE_ENQUIRIES = gql`
    mutation BulkUnArchiveEnquiries($bulkUnArchiveEnquiriesInput: ArchiveOrResolveEnquiriesInput!) {
        bulkUnArchiveEnquiries(bulkUnArchiveEnquiriesInput: $bulkUnArchiveEnquiriesInput) {
            message
        }
    }
`;

//Extension
export const UPDATE_AUTHORIZED_EMAIL = gql`
    mutation UpdateAuthorizedEmail($body: ExtensionInput!) {
        updateAuthorizedEmail(body: $body) {
            message
        }
    }
`;

export const VERIFY_EMAIL = gql`
    mutation VerifyExtensionEmail($body: EmailInput!) {
        verifyExtensionEmail(body: $body) {
            message
        }
    }
`;

export const DISCONNECT_EMAIL = gql`
    mutation disconnectEmail($body: EmailInput!) {
        disconnectEmail(body: $body) {
            email
        }
    }
`;

export const ENABLE_EMAIL_EXTENSION = gql`
    mutation AddAuthorizedCompany {
        addAuthorizedCompany {
            companyId
        }
    }
`;
export const UPDATE_PROFILE_IMAGE = gql`
    mutation UpdateUserProfileImage($updateProfileImageInput: UpdateProfileImageInput!) {
        updateUserProfileImage(updateProfileImageInput: $updateProfileImageInput) {
            _id
            acceptedEmailCommunication
            acceptedTAndC
            companyCreator
            email
            emailChangedTime
            acceptedWelcomeEmail
            firstName
            hasClickedIntegrationButton
            hasViewedIntegrationModal
            hasViewedQuickResponseInfo
            jobTitle
            lastLoggedInAt
            lastName
            plan
            mobileNum
            profileImage
            receiveNotification
            registeredWithGoogle
            stripeCustomerId
            subscriptionRenewable
            subscriptionStatus
            userName
            verifiedAt
        }
    }
`;

export const UPDATE_TEAM_MEMBER_ACCOUNT_PERMISSIONS = gql`
    mutation UpdateTeamMemberPermission($teamMemberPermissionInput: AddUserPermission!) {
        updateTeamMemberPermission(teamMemberPermissionInput: $teamMemberPermissionInput) {
            _id
            teamMembers {
                userId
                teamMemberRole
                permissions {
                    name
                    allowed
                    acessType
                }
                locked
                jobTitle
                invitationAccepted
                createdAt
            }
        }
    }
`;

/**Stock Market Data Mutations */
export const CREATE_STOCK_WATCHLIST = gql`
    mutation CreateStockWatchlist($watchlistInput: CreateWatchlistInput!) {
        createStockWatchlist(watchlistInput: $watchlistInput) {
            watchlistId
            name
            description
            companyId
            createdBy
            createdAt
            message
        }
    }
`;

export const UPDATE_STOCK_WATCHLIST = gql`
    mutation UpdateStockWatchlist($updateWatchlistInput: UpdateWatchlistInput!) {
        updateStockWatchlist(updateWatchlistInput: $updateWatchlistInput) {
            watchlistId
            name
            description
            updatedAt
            message
        }
    }
`;

export const DELETE_STOCK_WATCHLIST = gql`
    mutation DeleteStockWatchlist($deleteWatchlistInput: DeleteWatchlistInput!) {
        deleteStockWatchlist(deleteWatchlistInput: $deleteWatchlistInput) {
            message
            deletedWatchlistId
        }
    }
`;

export const ADD_STOCK_TO_WATCHLIST = gql`
    mutation AddStockToWatchlist($addStockInput: AddStockToWatchlistInput!) {
        addStockToWatchlist(addStockInput: $addStockInput) {
            watchlistId
            symbol
            addedAt
            message
        }
    }
`;

export const REMOVE_STOCK_FROM_WATCHLIST = gql`
    mutation RemoveStockFromWatchlist($removeStockInput: RemoveStockFromWatchlistInput!) {
        removeStockFromWatchlist(removeStockInput: $removeStockInput) {
            watchlistId
            symbol
            message
        }
    }
`;

export const CREATE_STOCK_ALERT = gql`
    mutation CreateStockAlert($alertInput: CreateStockAlertInput!) {
        createStockAlert(alertInput: $alertInput) {
            alertId
            symbol
            alertType
            condition
            targetPrice
            isActive
            createdAt
            message
        }
    }
`;

export const UPDATE_STOCK_ALERT = gql`
    mutation UpdateStockAlert($updateAlertInput: UpdateStockAlertInput!) {
        updateStockAlert(updateAlertInput: $updateAlertInput) {
            alertId
            isActive
            targetPrice
            condition
            updatedAt
            message
        }
    }
`;

export const DELETE_STOCK_ALERT = gql`
    mutation DeleteStockAlert($deleteAlertInput: DeleteStockAlertInput!) {
        deleteStockAlert(deleteAlertInput: $deleteAlertInput) {
            message
            deletedAlertId
        }
    }
`;

export const SYNC_STOCK_DATA = gql`
    mutation SyncStockData($syncInput: SyncStockDataInput!) {
        syncStockData(syncInput: $syncInput) {
            message
            symbolsUpdated
            lastSyncTime
            totalDataPoints
        }
    }
`;

export const UPDATE_STOCK_DATA_PREFERENCES = gql`
    mutation UpdateStockDataPreferences($preferencesInput: StockDataPreferencesInput!) {
        updateStockDataPreferences(preferencesInput: $preferencesInput) {
            companyId
            defaultCurrency
            defaultExchange
            autoRefreshInterval
            enableRealTimeUpdates
            preferredDataProvider
            updatedAt
            message
        }
    }
`;

/**Real-time Stock Data Subscriptions - These would be used with subscriptions in GraphQL */
export const STOCK_PRICE_UPDATED = gql`
    subscription StockPriceUpdated($subscriptionInput: StockSubscriptionInput!) {
        stockPriceUpdated(subscriptionInput: $subscriptionInput) {
            symbol
            price
            change
            changePercent
            volume
            timestamp
            source
        }
    }
`;

export const WATCHLIST_UPDATED = gql`
    subscription WatchlistUpdated($watchlistId: String!) {
        watchlistUpdated(watchlistId: $watchlistId) {
            watchlistId
            symbol
            price
            change
            changePercent
            timestamp
            updateType
        }
    }
`;

export const STOCK_ALERT_TRIGGERED = gql`
    subscription StockAlertTriggered($companyId: String!) {
        stockAlertTriggered(companyId: $companyId) {
            alertId
            symbol
            currentPrice
            targetPrice
            condition
            alertType
            triggeredAt
            message
        }
    }
`;
